import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import AboutAlex from './pages/AboutAlex';
import Flying from './pages/Flying';
import FlyingInNZ from './pages/FlyingInNZ';
import Travel from './pages/Travel';
import './App.css';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about_alex" element={<AboutAlex />} />
          <Route path="/flying" element={<Flying />} />
          <Route path="/flyinginnz" element={<FlyingInNZ />} />
          <Route path="/travel" element={<Travel />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
